// SPDX-License-Identifier: AGPL-3.0-or-later

import * as Modal from '@app/features/app/components/dialogs/Modal';
import {Button} from '@app/features/ui/button/Button';
import styles from '@app/features/voice/components/alerts/VoiceConnectionConfirmModal.module.css';
import {
	useVoiceConnectionConfirmModalLogic,
	type VoiceConnectionConfirmModalProps,
} from '@app/features/voice/utils/VoiceConnectionConfirmModalUtils';
import {plural} from '@lingui/core/macro';
import {Trans, useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
export const VoiceConnectionConfirmModal: React.FC<VoiceConnectionConfirmModalProps> = observer(
	({guildId, channelId, onSwitchDevice, onJustJoin, onCancel}) => {
		const {t} = useLingui();
		const {existingConnectionsCount, handleSwitchDevice, handleJustJoin, handleCancel} =
			useVoiceConnectionConfirmModalLogic({
				guildId,
				channelId,
				onSwitchDevice,
				onJustJoin,
				onCancel,
			});
		return (
			<Modal.Root size="small" centered>
				<Modal.Header title={t`Voice Connection Confirmation`} />
				<Modal.Content>
					{plural(
						{count: existingConnectionsCount},
						{
							one: "You're already connected to this voice channel from # other device. What would you like to do?",
							other: "You're already connected to this voice channel from # other devices. What would you like to do?",
						},
					)}
				</Modal.Content>
				<Modal.Footer>
					<div className={styles.footer}>
						<Button variant="primary" onClick={handleSwitchDevice} className={styles.fullWidth}>
							<Trans>Switch to This Device</Trans>
						</Button>
						<Button variant="secondary" onClick={handleJustJoin} className={styles.fullWidth}>
							<Trans>Just Join (Keep Other Connections)</Trans>
						</Button>
						<Button variant="secondary" onClick={handleCancel} className={styles.fullWidth}>
							<Trans>Do nothing, I don't want to join</Trans>
						</Button>
					</div>
				</Modal.Footer>
			</Modal.Root>
		);
	},
);
